const accentColor = 'var(--theme-accent, #f97316)'

const EditCircleIcon = ({ dark }: { dark?: boolean }) => (
  <svg
    fill="none"
    height="35"
    viewBox="0 0 35 35"
    width="35"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle
      cx="17.5"
      cy="17.5"
      r="17.5"
      style={{ fill: dark ? 'white' : accentColor }}
    />
    <path
      d="M12 23.5934H14.4842L23.5934 14.4842L21.1089 12L12 21.1092V23.5934Z"
      strokeLinejoin="round"
      strokeWidth="2"
      style={{ stroke: dark ? accentColor : '#F3F3F0' }}
    />
    <path
      d="M18.625 14.4844L21.1092 16.9686"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      style={{ stroke: dark ? accentColor : '#F3F3F0' }}
    />
  </svg>
)

export default EditCircleIcon
